import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { PageLoader } from "./components/page-loader";
import { AuthenticationGuard } from "./components/authentication-guard";
import { Route, Routes } from "react-router-dom";
import { CallbackPage } from "./pages/callback-page";
import { EmailVerifiedPage } from "./pages/email-verified-page";
import { HomePage } from "./pages/home-page";
import { NotFoundPage } from "./pages/not-found-page";
import { ProfilePage } from "./pages/profile-page";
import { DashboardPage } from "./pages/dashboard-page";
import { DocumentsPage } from "./pages/documents-page";
import { AboutPage } from "./pages/about-page";
import { PricingPage } from "./pages/pricing-page";
import { FreebieDownloadablesPage } from "./pages/freebie-downloadables-page";
import { PromoClaimPage } from "./pages/promo-claim-page";
import { DocumentStorageProvider } from "./contexts/DocumentStorageContext";
import { useAuthenticationTracking } from "./hooks/useAuthenticationTracking";
import { usePageViewTracking } from "./hooks/usePageViewTracking";
import { usePostHogPageview } from "./hooks/usePostHogPageview";
import { usePostHogIdentify } from "./hooks/usePostHogIdentify";
import { Seo } from "./components/seo";

export const App: React.FC = () => {
  const { isLoading } = useAuth0();

  // Initialize authentication tracking
  useAuthenticationTracking();

  // Initialize page view tracking
  usePageViewTracking();

  // Initialize PostHog analytics
  usePostHogPageview();
  usePostHogIdentify();

  if (isLoading) {
    return (
      <>
        <Seo />
        <div className="page-layout">
          <PageLoader />
        </div>
      </>
    );
  }
  return (
    <>
      <Seo />
      <DocumentStorageProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route
            path="/freebie-downloadables"
            element={<FreebieDownloadablesPage />}
          />
          <Route
            path="/profile"
            element={<AuthenticationGuard component={ProfilePage} />}
          />
          <Route
            path="/dashboard"
            element={<AuthenticationGuard component={DashboardPage} />}
          />
          <Route
            path="/documents"
            element={<AuthenticationGuard component={DocumentsPage} />}
          />
          <Route
            path="/promo/free-week"
            element={<AuthenticationGuard component={PromoClaimPage} />}
          />
          <Route path="/home" element={<HomePage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/email-verified" element={<EmailVerifiedPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </DocumentStorageProvider>
    </>
  );
};
